import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Stack from "@mui/material/Stack";
import { CreditCard } from "@phosphor-icons/react/CreditCard";
import { FC } from "react";
import {
	Account,
	AccountUsageStats,
} from "~ui-components/types/__generated/gql/graphql";
import { Summary } from "../subscription-summary";

export const PaidUserAccount: FC<{
	account: Account;
	accountUsageStats: AccountUsageStats;
}> = (props) => {
	return (
		<Card>
			<CardHeader
				avatar={
					<Avatar>
						<CreditCard fontSize="var(--Icon-fontSize)" />
					</Avatar>
				}
				title="Subscription summary"
			/>
			<CardContent>
				<Stack spacing={3}>
					<Summary {...props} />
				</Stack>
			</CardContent>
		</Card>
	);
};
